module.exports = __webpack_public_path__ + "static/media/pinpoint-customers-icon.653c9e77.svg";